module.exports = __webpack_public_path__ + "img/eye.1df35dae.svg";